import styled from "styled-components";
import { breakpoints } from "styles";
import { colors, spacing, stroke } from "design-system/foundation";

export const PracticeOuterWrapper = styled.div`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  border-top: ${stroke.xs} solid ${colors.border.state.default};
`;

export const PracticeWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding-bottom: ${spacing["5xl"]};
  margin: ${spacing.none} auto;
  flex-direction: column;
  @media ${breakpoints.tablet} {
    flex-direction: row;
    height: calc(100vh - 80px);
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const Divider = styled.div`
  height: ${stroke.xs};
  width: 100%;
  background: ${colors.border.state.default};
  margin-top: ${spacing["5xl"]};

  @media ${breakpoints.tablet} {
    height: auto;
    width: ${stroke.xs};
  }
`;
